import { render, staticRenderFns } from "./testContent.vue?vue&type=template&id=2bca45ab&scoped=true&"
import script from "./testContent.vue?vue&type=script&lang=js&"
export * from "./testContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca45ab",
  null
  
)

export default component.exports